import store from '@/store'

export default {
    // When the bound element is inserted into the DOM...
    inserted: function (el, binding) {
        if (store.getters['company/features'].indexOf(binding.value) === -1) {
            el.remove()
        }
    }
}
